import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  saving: boolean;

  @Input()
  title: string;

  @Input()
  message: string;

  @Input()
  yesNoButtons: boolean;

  @Output()
  confirmClicked = new EventEmitter<boolean>();

  @Output()
  closed = new EventEmitter<boolean>();

  constructor() {
    this.yesNoButtons = false;
    this.saving = false;
  }

  ngOnInit() {
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  close() {
    this.closed.emit(true);
  }

  confirm() {
    this.saving = true;
    this.confirmClicked.emit(true);
  }
}
